import React from 'react';
import FCategoryIcon, {
    F_CATEGORIES,
    resolveFCategory,
} from '../../DashboardV2/fCategoryIcons';

/**
 * Portal V2 F glyphs — same Lucide-style icons as Dashboard V2.
 * Outer chrome (circles, borders, glow) stays in each section's CSS.
 */

export function fIconIndex(name = '', fallbackIndex = 0) {
    const key = resolveFCategory(name);
    if (key) {
        const i = F_CATEGORIES.indexOf(key);
        return i >= 0 ? i : fallbackIndex;
    }
    const n = Number(fallbackIndex);
    return Number.isFinite(n) ? Math.min(6, Math.max(0, n)) : 0;
}

/** Index-aligned icon components (Dashboard glyphs). */
export const F_LINE_ICONS = F_CATEGORIES.map((category) => {
    function DashFIcon() {
        return <FCategoryIcon category={category} size="100%" />;
    }
    DashFIcon.displayName = `FLineIcon_${category}`;
    return DashFIcon;
});

/**
 * Renders the Dashboard V2 F icon for a life area.
 * `className` stays on the wrapper so section layouts keep sizing/chrome.
 */
export function FLineIcon({ name, index = 0, className }) {
    const category =
        resolveFCategory(name) ||
        F_CATEGORIES[fIconIndex('', index)] ||
        F_CATEGORIES[0];

    return (
        <span
            className={className || undefined}
            style={className ? undefined : { display: 'contents' }}
        >
            <FCategoryIcon category={category} size="100%" />
        </span>
    );
}
